module.exports = __webpack_public_path__ + "img/list-bg2.ca2c338a.png";